import { render, staticRenderFns } from "./CollectionsSelectorMobile.vue?vue&type=template&id=4dd54cc6&"
import script from "./CollectionsSelectorMobile.vue?vue&type=script&lang=ts&"
export * from "./CollectionsSelectorMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports